import api from "./api";

export async function gotoSpotifyAuthUrl() {
    let response = await api.get("spotify_auth", {
        params: { redirect: `http://${window.location.host}/authorised` }
    });
    window.location.href = response.data;
}
